import { Button, styled, Typography, useMediaQuery, useTheme } from '@mui/material';
import ListCell from 'components/list/list-cell';
import ListRow from 'components/list/list-row';
import { useAccountState } from 'contexts/account/account-context';
import saveAs from 'file-saver';
import React from 'react';
import { FormattedDate, useIntl } from 'react-intl';
import googleTagManager from 'utils/google-tag-manager';
import { getDownloadFile } from 'views/file-sharing/api/file-sharing';
import { SharedFile } from '../types/shared-folder.type';

const TextWrapper = styled(Typography)(({ theme }) => ({
  wordWrap: 'break-word',
  maxWidth: 200,

  [theme.breakpoints.up('md')]: {
    maxWidth: 2000,
  },
}));

type Props = {
  file: SharedFile;
};

const FileRow: React.FC<Props> = ({ file }) => {
  const { account } = useAccountState();
  const intl = useIntl();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const handleFileDownload = () => {
    if (account.company?.companyId) {
      if (file) {
        getDownloadFile(account.company.companyId, file.id).then((res) => {
          saveAs(res.data, file.name, { autoBom: false });
        });

        googleTagManager.push({
          event: 'download',
          fileName: file.name,
          fileType: file.name.split('.')[1] || file.name,
          pageUrl: window.location.pathname,
          siteId: '',
        });
      }
    }
  };

  return (
    <ListRow key={file.id}>
      <ListCell align="left">
        <TextWrapper whiteSpace={'pre-wrap'}>{file.name}</TextWrapper>
      </ListCell>
      <ListCell align="left">
        <FormattedDate value={file.dateCreated} />
      </ListCell>
      <ListCell>
        <Button size="small" onClick={() => handleFileDownload()}>
          {intl.formatMessage({ id: 'general.download' })}
        </Button>
      </ListCell>
    </ListRow>
  );
};

export default React.memo(FileRow);
